import styled from 'styled-components';
import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';

export default styled(Block)`
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
`;
